'use strict';

wbApp.controller('ActionsStudentsDetailCtrl', ['$scope', 'securitySvc', 'messageBoxSvc', 'courseRegistrationSvc', 'tenantSettingSvc',
    'localStorageService', '$translate',
function ($scope, securitySvc, messageBoxSvc, courseRegistrationSvc, tenantSettingSvc, localStorageService, $translate) {

    $scope.allowDiscounts = tenantSettingSvc.settings.allowDiscounts;
    $scope.calculatedDueDate = { dueDate: null };
    $scope.modelOrig = angular.copy($scope.model);
    $scope.registeredAttendance = [];

    $scope.isReady = false;
    $scope.isBusy = false;

    $scope.onRegistrationDateChange = function(registrationDate) {
        if ($scope.allowDiscounts) {
            courseRegistrationSvc.calcExpectedDueDate($scope.action.courseID, registrationDate).$promise.then( function(data) {
                $scope.calculatedDueDate.dueDate = data.dueDate;
            });
        }
    }
        
    function extendModel(action) {

        setIsBusy(true);

        courseRegistrationSvc.initializeModel($scope.model, action, true, true)
        .then(function () {
            $scope.modelOrig = angular.copy($scope.model);
            $scope.registeredAttendance = $scope.model.registeredAttendance;

            if ($scope.allowDiscounts) {
                courseRegistrationSvc.calcExpectedDueDate($scope.action.courseID, $scope.model.registrationDate).$promise.then( function(data) {
                    $scope.calculatedDueDate.dueDate = data.dueDate;
                });
            }            
            
            setIsBusy(false);
        },
        function (errorResult) {
            $scope.registeredAttendance = [];
            $scope.detailError = errorResult;

            setIsBusy(false);
        });
    }

    function setIsBusy(isBusy) {
        $scope.isBusy = isBusy;
        $scope.isReady = !isBusy;
        angular.forEach($scope.detailTabs, function (tab) {
            tab.disabled = isBusy;
        });
    }


    extendModel($scope.action);

    $scope.onStudentChange = function (studentID) {
        extendModel($scope.action);
    }

    $scope.onAttendanceCountChange = function (model) {
        courseRegistrationSvc.updateReservedPlaces(model, model.reservedPlaces);
    }

    $scope.isSaving = false;

    $scope.onDetailSave = function (model) {

        $scope.saveManualAdjustmentTextToLocalStorage(model.invoice);

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        function success() {
            $scope.onAfterSuccessSave();
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        function cancel() {
            $scope.isSaving = false;
        }

        function confirmUpdate(updateInvoice) {
            messageBoxSvc.showConfirmClientNotification({
                userSetting: ['confirmNotificationEventStudent'],
                showSendSmsNotification: false,
                callback: function (notificationConfig) {
                    courseRegistrationSvc.update(
                        model,
                        notificationConfig,
                        2, /* SubjectCategory.OneOffActions */
                        updateInvoice,
                        success,
                        error);
                }
            });
        }

        if (!model.courseRegistrationID) {
            messageBoxSvc.showConfirmClientNotification({
                userSetting: ['confirmNotificationEventStudent'],
                showSendSmsNotification: false,
                callback: function (notificationConfig) {
                    courseRegistrationSvc.insert(
                        model,
                        notificationConfig,
                        2, /* SubjectCategory.OneOffActions */
                        success,
                        error);
                }
            });
        } else {
            if (model.invoice.isModified) {
                // Invoice has changed, ask user for confirmation
                messageBoxSvc.showMessageDlg({
                    title: 'TXT_TITLE_CONFIRMATION',
                    message: 'TXT_TEXT_INVOICE_HAS_CHANGED',
                    buttons: [{
                        text: 'TXT_BTN_CANCEL',
                        callback: cancel
                    }, {
                        text: 'TXT_BTN_NO_INVOICE_CHANGES',
                        callback: function () { confirmUpdate(false); }
                    }, {
                        text: 'TXT_BTN_CREATE_NEW_INVOICE',
                        callback: function () { confirmUpdate(true); }
                    }]
                });
            } else {
                courseRegistrationSvc.update(
                    model,
                    {
                        sendEmailNotification: false,
                        sendSmsNotification: false                    
                    },
                    2, /* SubjectCategory.OneOffActions */
                    false,
                    success,
                    error);
            }

        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig) &&
            (!!$scope.model.invoice && !$scope.model.invoice.isModified) &&
            !!$scope.model.courseRegistrationID;
    };

    $scope.detailTabs = [
    {
        title: 'TXT_MAIN',
        template: 'actions/actions/actions-detail-tabs/students-detail-main-tab.html',
        disabled: true,
    }, {
        title: 'TXT_PRICE_TAB',
        template: 'actions/actions/actions-detail-tabs/students-detail-price-tab.html',
        disabled: true,
    }, {
        title: 'TXT_LBL_PARENT',
        template: 'actions/actions/actions-detail-tabs/students-detail-parent-tab.html',
        disabled: true,
    }];

    $scope.detailTabs.activeTab = 0;

    $scope.saveManualAdjustmentTextToLocalStorage = function (invoice) {
        if (localStorageService.isSupported) {
            var manualAdjustmentLine = _.find(invoice.lines, function (line) {
                return line.lineType == "ManualAdjustment" && line.runtimeManualAdjustmentType == 1;
            });

            if (!!manualAdjustmentLine) {
                localStorageService.set('manualAdjustmentDiscountLineName', manualAdjustmentLine.name);
                localStorageService.set('manualAdjustmentDiscountLinePercent', manualAdjustmentLine.percent);
            }
        }
    }

    $scope.addInvoiceLine = function (manualAdjustmentLineType) {
        var newLine = $scope.model.invoice.addManualAdjustmentLine(manualAdjustmentLineType);
        if (manualAdjustmentLineType == 1) {

            if (localStorageService.isSupported) {
                newLine.name = localStorageService.get('manualAdjustmentDiscountLineName') || $translate.instant('TXT_DISCOUNT');
                newLine.percent = localStorageService.get('manualAdjustmentDiscountLinePercent') || 0;
            } else {
                newLine.name = $translate.instant('TXT_DISCOUNT');
            }
        }
    }

    $scope.removeInvoiceLine = function (invoice, index) {
        invoice.removeManualAdjustmentLine(index);
    }

    $scope.addManualAdjustmentLineDropdown = [
        {
            text: $translate.instant('TXT_ADD_LINE_DISCOUNT_IN_PERCENT'),
            click: 'addInvoiceLine(1)'
        },
        {
            text: $translate.instant('TXT_ADD_LINE_EMPTY'),
            click: 'addInvoiceLine(0)'
        }
    ];

}]);
